import React, { useState, useEffect, useRef } from 'react'
import FileDownload from 'js-file-download'
import Layout from '../../components/Layout'
import Header from '../../components/shared/Header'
import ExcelIcon from '../../../assets/icons/ic_excel.svg';
import SendIcon from '../../../assets/icons/ic_send-email.svg';
import ListItems from '../../components/shared/ListItems';
import './ManifestHistory.scss';
import ItemHistory from '../../components/shared/ItemHistory';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import CustomSelect from '../../components/shared/CustomSelect';
import MultiInputDate from '../../components/shared/MultiInputDate';
import { useDispatch, useSelector } from 'react-redux';
import { loadingActions, filterActions } from '../../redux/actions';
import manifestAPI from '../../api/manifestAPI';
import Modal from '../../components/shared/Modal';
import enterprisesAPI from '../../api/enterprisesAPI';
import storesAPI from '../../api/storesAPI';
import moment from 'moment';
import EmailsModal from '../../components/shared/EmailsModal';
import AnotherSessionModal from '../../components/shared/AnotherSessionModal';
import { sessionError } from '../../utils/sessionError';

const ManifestHistory = () => {

  // const [filters, setFilters] = useState({
  //   enterprises:[],
  //   stores:[],
  //   startDate: null,
  //   endDate: null
  // })
  const [companiesOption, setCompaniesOption] = useState([
    {
      label: 'Empresas',
      options: [],
    },
  ])
  const [storesOption, setStoresOption] = useState([
    {
      label: 'Sucursal',
      options: [],
    },
  ])
  const [modalSession, setModalSession] = useState(false)
  const [modalError, setModalError] = useState(false)
  const [modalReportError, setModalReportError] = useState(false)
  const [modalEmails, setModalEmails] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch()
  const [selectedRow, setSelectedRow] = useState('')
  const didMounRef = useRef(false);
  const didMounRef2 = useRef(false);
  const [checkManifest, setCheckManifest] = useState([]);
  const filters = useSelector(state => state.filterReducer.filtersHistory)

  useEffect(() => {
    fetchManifest(currentPage, perPage)
    fetchCompanies()
    fetchStores()
    // CLEAN FILTERS FROM ALL OTHER TABS
    cleanAllOtherFilters();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if(filters.startDate && !filters.endDate) return
    if(filters.endDate && !filters.startDate) return
    const timeout = setTimeout(() => {
      if (perPage !== '') {
        if(didMounRef2.current)onChangePerPage(perPage);
        else didMounRef2.current = true;
      }
    }, 800);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [filters])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (perPage !== '') {
        if(didMounRef.current)onChangePerPage(perPage);
        else didMounRef.current = true;
        // console.log(numElem);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [perPage]);

  const cleanAllOtherFilters = () => {
    dispatch(filterActions.cleanResend());
    dispatch(filterActions.cleanStates());
    dispatch(filterActions.cleanReassign());
  }

  const formatManifest = (manifests) => {
    return manifests.map(manifest => ({
      ...manifest,
      checked: checkManifest.includes(manifest.registerDate),
    }))
  }

  const formatFilters = ({startDate, endDate, stores, enterprises }) => {
    const newFilters = {
      startDate: startDate && moment(startDate).format('YYYY-MM-DD'),
      endDate: endDate && moment(endDate).format('YYYY-MM-DD'),
      stores: Array.isArray(stores) ? stores : [stores],
      enterprises: Array.isArray(enterprises) ? enterprises : [enterprises],
    }
    return newFilters
  }

  const fetchManifest = async (currentPage, perPage) => {
    try {
      dispatch(loadingActions.setLoading(true))
      const { total, manifests } = await manifestAPI.getHistory(currentPage, perPage, formatFilters(filters));
      console.log(total, manifests)
      setRows(formatManifest(manifests));
      setTotal(total)
      setTotalPages(Math.ceil(parseInt(total) / parseInt(perPage)))
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      console.error(error);
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  const fetchCompanies = async () => {
    try {
      const companies = await enterprisesAPI.getEnterprises();
      console.log(companies, 'COMPANIES')
      const formatCompanies = companies.map( c => ({...c, value: c.id, label: c.name}))
      setCompaniesOption([{
        label: 'Empresas',
        options: formatCompanies,
      }])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  const fetchStores = async () => {
    try {
      const stores = await storesAPI.getStores();
      console.log(stores, 'stores')
      const formatStores = stores.map( s => ({...s, value: s.id, label: s.name}))
      setStoresOption([{
        label: 'Sucursal',
        options: formatStores,
      }])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  const onChangePage = async (numPage, perPage) => {
    setCurrentPage(numPage);
    fetchManifest(numPage, perPage)
  }

  const onChangePerPage = async (perPage) => {
    if(perPage <= 0) return;
    setCurrentPage(1);
    await fetchManifest(1, perPage)
  }

  const handleClickCheckbox = (row, rowIndex) => {
    const newRows = [...rows];
    newRows[rowIndex] = { ...row, checked: !newRows[rowIndex]['checked'] };
    console.log(newRows);
    setRows(newRows);
    // console.log(newRows.map(nr => nr.lpn['value']));
    const rowsUnChecked = newRows.filter(nr => !nr.checked);
    let newCheckManifest = [...checkManifest];
    newCheckManifest.forEach((ncMani, i) => {
      const rowsUnCheckedFounded = rowsUnChecked.find(ruck => ruck['registerDate'] === ncMani)
      if(rowsUnCheckedFounded) newCheckManifest.splice(i, 1);
    });
    setCheckManifest([
      ...newCheckManifest,
      ...newRows.filter(n => n.checked && !checkManifest.includes(n.registerDate)).map(nr => nr.registerDate)
    ]);
  }

  const checkRowsChecked = () => {
    // const isAnyRowChecked = rows.some(r => r.checked === true);
    // console.log(isAnyRowChecked);
    return checkManifest.length<=0 ? true : false;
  }

  const exportData = async (dates, filters) => {
    try {
      dispatch(loadingActions.setLoading(true))
      const excel = await manifestAPI.exportExcelHistory(dates, formatFilters(filters));
      const dateObj = new Date()
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
      const date = ('0' + dateObj.getDate()).slice(-2)
      const year = dateObj.getFullYear()
      const fileName = `historial_manifiestos_${date}${month}${year}.xlsx`
      FileDownload(excel, fileName)
      // console.log(excel)
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      console.log(error)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      } else {
        setModalReportError(true)
      }
    }
  }

  const sendEmail = async (emailsList, filters) => {
    try {
      dispatch(loadingActions.setLoading(true))
      console.log(emailsList)
      if(selectedRow) await manifestAPI.sendEmailHistory([selectedRow], emailsList, formatFilters(filters));
      else await manifestAPI.sendEmailHistory(checkManifest, emailsList, formatFilters(filters));
      setModalEmails(false)
      setSelectedRow('')
      dispatch(loadingActions.setLoading(false))
    } catch(e) {
      console.log(e)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  return (
    <Layout>
      <AnotherSessionModal isOpen={modalSession} onClose={() => setModalSession(false)} />
      <Modal
        visible={modalError}
        onClose={() => {}}
        title='No hay conexión'
        titleImage={require('../../../assets/icons/ic_disconnected.svg')}
        color='var(--ripley-salmon)'
        btn1={{
          text: 'Volver',
          type: 'secondary',
          onClick: () => {
            setModalError(false)
          }
        }}
        btn2={{
          text: 'Reintentar',
          type: 'primary',
          onClick: () => {
            setModalError(false)
            fetchManifest()
          }
        }}
      >
        <div className='modal-error'>
          <p>Revisa tu conexión a internet e inténtalo de nuevo</p>
        </div>
      </Modal>
      <Modal
        visible={modalReportError}
        onClose={() => setModalReportError(false)}
        title='No hay conexión'
        titleImage={require('../../../assets/icons/ic_disconnected.svg')}
        color='var(--ripley-salmon)'
        btn1={{
          text: 'Volver',
          type: 'secondary',
          onClick: () => {
            setModalReportError(false)
          }
        }}
        btn2={{
          text: 'Reintentar',
          type: 'primary',
          onClick: () => {
            setModalReportError(false)
            exportData(checkManifest)
          }
        }}
      >
        <div className='modal-error'>
          <p>No se pudo descargar el reporte. Revisa tu conexión a internet e inténtalo de nuevo</p>
        </div>
      </Modal>
      <EmailsModal
        title='Reenviar manifiestos por correo'
        titleImage={require('../../../assets/icons/mail.svg')}
        visible={modalEmails}
        onClose={() => { setModalEmails(false); setSelectedRow('')}}
        onFinish={emailsList => sendEmail(emailsList, filters)}
      />
      <div className='manifest-history-container'>
        <Header
          title='Manifiestos'
          subtitle='Historial de reportes'
          btnTitle1='Exportar selección'
          onClickBtn1={() => exportData(checkManifest, filters)}
          disabledBtn1={checkRowsChecked()}
          iconBtn1={ExcelIcon}
          btnTitle2='Enviar selección'
          onClickBtn2={() => setModalEmails(true)}
          disabledBtn2={checkRowsChecked()}
          iconBtn2={SendIcon}
          // btnTitle3='Exportar todo'
          // onClickBtn3={exportAll}
          // disabledBtn3={false}
          // iconBtn3={ExcelIcon}
        />
        <div className='manifest-history-filters'>
          <div className='manifest-history-select company'>
            <CustomSelect
              value={filters.enterprises}
              onChange={(e) => dispatch(filterActions.setHistory({ ...filters, enterprises:e})) }
              placeholder='Empresas'
              options={companiesOption}
              multi
            />
          </div>
          <div className='manifest-history-select location'>
            <CustomSelect
              value={filters.stores}
              onChange={(e) => dispatch(filterActions.setHistory({ ...filters, stores:e})) }
              placeholder='Sucursales'
              options={storesOption}
              multi
            />
          </div>
          <div className='manifest-history-select multidate'>
            <MultiInputDate
              value1={filters.startDate}
              onChange1={(e) => dispatch(filterActions.setHistory({ ...filters, startDate: e })) }
              label1='Fecha Inicio'
              value2={filters.endDate}
              onChange2={(e) => dispatch(filterActions.setHistory({ ...filters, endDate: e })) }
              label2='Fecha Fin'
              cleanBoth={() => { dispatch(filterActions.setHistory({ ...filters, startDate: null, endDate: null })) }}
              fullWidth
            />
          </div>
        </div>
        <div className='manifest-history-table'>
          <ListItems
            currentPage={currentPage}
            total={total}
            perPage={perPage}
            totalPages={totalPages}
            changePage={onChangePage}
            onChangePerPage={(e) => setPerPage(e.target.value)}
          >
            {
              rows.map((r,i) => (
                <ItemHistory
                  row={r}
                  rowIndex={i}
                  onClickCheckBox={handleClickCheckbox}
                  registerDate={r.registerDate}
                  manifestCount={r.manifestsCount}
                  ticketsNumber={r.ticketsNumber}
                  onClickExport={(date) => exportData([date], formatFilters(filters))}
                  onClickSend={(date) => {setSelectedRow(date); setModalEmails(true)}}
                  onClickDetail={() => history.push(`/historial-reportes/${r.registerDate}`, {manifest: r, filters: formatFilters(filters)})} />
              ))
            }
          </ListItems>
        </div>
      </div>
    </Layout>
  )
}

export default ManifestHistory
